import { ControlPosition, Map } from 'shared/map-exports';
import { LayersOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useMapGLController } from 'features/mapping/hooks/useMapGLController/useMapGLController';
import { MapControlButton } from '../MapControlButton';
import {
  BaseMapboxGLController,
  BaseMapboxGLControllerProps,
} from '../BaseMapboxGLController';

type LayersControlProps = {
  setDrawerOpen: () => void;
  position?: ControlPosition;
};

const LayersControlContent = (props: LayersControlProps): JSX.Element => {
  const { setDrawerOpen } = props;
  const { t } = useTranslation();

  return (
    <MapControlButton
      text={t('map.controls.layers')}
      onClick={setDrawerOpen}
      Icon={LayersOutlined}
    />
  );
};

class MapboxGLLayersController extends BaseMapboxGLController<
  LayersControlProps & BaseMapboxGLControllerProps & { map?: Map }
> {
  content = (): JSX.Element => (
    <LayersControlContent map={this.map} {...this.props} />
  );
}

export const LayersControl = (props: LayersControlProps): null => {
  useMapGLController(props, MapboxGLLayersController);
  return null;
};
